export default function Logo(props){
    return <div className='logo'></div>

}